import React from 'react';
import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';

const LanguageMenu = () => {
  const { i18n } = useTranslation();

  const languages = ['en', 'es'];

  return (
    <Menu>
      {languages.map((lng) => (
        <Menu.Item
          key={lng}
          onClick={() => i18n.changeLanguage(lng)}
          style={{
            fontWeight: i18n.language === lng ? 'bold' : 'normal',
            color: i18n.language === lng ? '#318c8d' : undefined,
            backgroundColor: i18n.language === lng ? '#f2f2f2': undefined
          }}
        >
          {lng.toUpperCase()}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default LanguageMenu;
